import { createSelector } from 'redux-starter-kit';

const ssoSelector = createSelector(['sso'], sso => sso);

export const tokenDataSelector = createSelector(
  [ssoSelector],
  sso => sso.tokenData,
);
